import "core-js/modules/es.array.map.js";
import { filterByType } from "../../../data";
import { useApplicationPageAggregatedData } from "./aggregatedData";
export var StepStatus = /*#__PURE__*/function (StepStatus) {
  StepStatus["Complete"] = "complete";
  StepStatus["InProgress"] = "in_progress";
  StepStatus["Incomplete"] = "incomplete";
  return StepStatus;
}({});
export function useApplicationSteps() {
  var _useApplicationPageAg = useApplicationPageAggregatedData({
      select: function select(aggregatedData) {
        var _filterByType;
        return (_filterByType = filterByType(aggregatedData.included, 'application_step')) === null || _filterByType === void 0 ? void 0 : _filterByType.map(function (step) {
          return step.attributes;
        });
      }
    }),
    data = _useApplicationPageAg.data,
    isLoading = _useApplicationPageAg.isLoading,
    error = _useApplicationPageAg.error;
  return {
    applicationSteps: data || [],
    isLoadingApplicationSteps: isLoading,
    applicationStepsError: error
  };
}